import axios from 'axios';

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/agreements";

// Validation failures come back as BadRequest(message): a plain string body, not { message }.
const messageFromResponse = (error, fallback) => {
  const data = error.response?.data;
  return (typeof data === 'string' && data) || data?.message || fallback;
};

//AGREEMENTS

// GET
export async function getAgreements(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/Agreements/get-agreements`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreements');
  }
} 

export const getAgreementsForUser = async (apiAccessToken) => {
  try {
    const response = await axios.get(`${baseUrl}/Agreements/get-agreements-for-user`, { // Corrected endpoint URL
      headers: {
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreements');
  }
};

export async function getAgreementByPublicId(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/Agreements/get-admin-agreement-by-public-id/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreement');
  }
}


// POST
export async function createAgreement(agreementData, apiAccessToken) {
  try {
    const response = await axios.post(`${baseUrl}/Agreements/create-agreement`, agreementData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    
    console.log("API Response for CreateAgreement:", response.data);
    
    return response.data;
  } catch (error) {
    
    console.error("API Request failed for CreateAgreement:", error.response?.data || error.message);
    
    throw new Error(error.response.data.message || 'Failed to create agreement');
  }
}


// PUT
export async function updateAgreement(agreementData, apiAccessToken) {
  try {
    const response = await axios.put(`${baseUrl}/Agreements/update-agreement`, agreementData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });

    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to update agreement');
  }
}


// DELETE
export async function deleteAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.delete(`${baseUrl}/Agreements/delete-agreement/${agreementPublicId}`, {
      headers: {
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to delete agreement');
  }
}

// ACCOUNTTYPE

// GET
export async function getAccountType(accountTypePublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/AccountType/get-account-type/${accountTypePublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch account types');
  }
}

export async function getAccountTypesByAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/AccountType/get-account-types-by-agreement/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  }
  catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch account types by agreement');
  }
}

// POST 
export async function createAccountType(accountTypeData, apiAccessToken) {
  try {
    const response = await axios.post(`${baseUrl}/AccountType/create-account-type`, accountTypeData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  }
  catch (error) {
    throw new Error(error.response.data.message || 'Failed to create account type');
  }
}

// PUT
export async function updateAccountType(accountTypeData, apiAccessToken) {
  try {
    const response = await axios.put(`${baseUrl}/AccountType/update-account-type`, accountTypeData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  }
  catch (error) {
    throw new Error(error.response.data.message || 'Failed to update account type');
  }
}

// DELETE

export async function deleteAccountType(accountTypePublicId, apiAccessToken) {
  try {
    const response = await axios.delete(`${baseUrl}/AccountType/delete-account-type/${accountTypePublicId}`,
      {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  }
  catch (error) {
    throw new Error(error.response.data.message || 'Failed to delete account type');
  }
}

// CONTACTPERSON

// Function to get contactperson by agreementId
export async function getContactPersonForAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(
      `${baseUrl}/ContactPerson/get-contact-person-for-agreement/${agreementPublicId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apiAccessToken}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("API Request failed:", error.response?.data || error);
    throw new Error(error.response?.data?.message || 'Failed to fetch contact person');
  }
} 

export async function getAllContactPersons(apiAccessToken) {
  try {
    const response = await axios.get(
      `${baseUrl}/ContactPerson/get-all-contact-persons`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apiAccessToken}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("API Request failed:", error.response?.data || error);
    throw new Error(error.response?.data?.message || 'Failed to fetch contact person');
  }
} 

// AGREEMENTSERVICE
// GET
export async function getAllAgreementServices(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/AgreementServices/get-all-agreement-services`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreement service');
  }
}

export async function getAgreementsForService(agreementServicePublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/AgreementServices/get-agreements-for-service/${agreementServicePublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreements for service');
  }
}

export async function getServiceCoverage(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/AgreementServices/get-service-coverage`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch service coverage');
  }
}

export async function getAgreementServicesforAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/AgreementServices/get-agreement-services-for-agreement/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreement service');
  }
}

export async function getAgreementService(agreementServicePublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/AgreementServices/get-agreement-service/${agreementServicePublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreement service');
  }
}

// POST
export async function addServiceToAgreement(serviceData,apiAccessToken) {
  /*
  {
  "agreementPublicId": "string",
  "agreementServicePublicId": "string",
  "comment": "string"
}
*/
  try {
    const response = await axios.post(`${baseUrl}/AgreementServices/add-agreement-service-to-agreement`, serviceData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreement service');
  }
}

export async function createAgreementService(serviceData, apiAccessToken) {

  try {
    const response = await axios.post(`${baseUrl}/AgreementServices/create-agreement-service`, serviceData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(messageFromResponse(error, 'Failed to fetch agreement service'));
  }
}

// PUT
export async function updateAgreementService(agreementServiceData, apiAccessToken) {

  try {
    console.log("Sending update request data:", agreementServiceData); // Debugging

    const response = await axios.put(`${baseUrl}/AgreementServices/update-agreement-service`, agreementServiceData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    console.log("✅ API Response:", response.data);

    return response.data;
  } catch (error) {
    throw new Error(messageFromResponse(error, 'Failed to update agreement'));
  }
}

// DELETE
export async function deleteAgreementService(agreementServicePublicId, apiAccessToken) {
  try {
    const response = await axios.delete(`${baseUrl}/AgreementServices/delete-agreement-service/${agreementServicePublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreement service');
  }
}

export async function removeServiceFromAgreement(agreementPublicId, agreementServicePublicId, apiAccessToken) {
  try {
    const response = await axios.delete(`${baseUrl}/AgreementServices/remove-agreement-service-from-agreement/${agreementPublicId}/${agreementServicePublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch agreement service');
  }
}

// AGREEMENTSERVICE CATEGORIES
export async function getAllServiceCategories(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/AgreementServiceCategory/get-all`, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${apiAccessToken}` }
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to fetch service categories');
  }
}

export async function createServiceCategory(data, apiAccessToken) {
  try {
    const response = await axios.post(`${baseUrl}/AgreementServiceCategory/create`, data, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${apiAccessToken}` }
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to create service category');
  }
}

export async function updateServiceCategory(data, apiAccessToken) {
  try {
    const response = await axios.put(`${baseUrl}/AgreementServiceCategory/update`, data, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${apiAccessToken}` }
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to update service category');
  }
}

export async function updateCategorySortOrder(data, apiAccessToken) {
  try {
    const response = await axios.put(`${baseUrl}/AgreementServiceCategory/update-sort-order`, data, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${apiAccessToken}` }
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to update category sort order');
  }
}

export async function updateServiceSortOrder(data, apiAccessToken) {
  try {
    const response = await axios.put(`${baseUrl}/AgreementServices/update-sort-order`, data, {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${apiAccessToken}` }
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to update service sort order');
  }
}

// AGREEMENTCONTACTS

// POST
export async function createAgreementContact(agreementContactData, apiAccessToken) {
  try {
    const response = await axios.post(`${baseUrl}/AgreementContacts/create-agreement-contact`, agreementContactData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  }
  catch (error) {
    throw new Error(error.response.data.message || 'Failed to create agreement contact');
  }
}

export async function replaceAgreementContacts(agreementPublicId, payload, apiAccessToken) {
  try {
    const response = await axios.put(`${baseUrl}/AgreementContacts/replace-agreement-contacts/${agreementPublicId}`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data; // { diflexContacts: [], customerContacts: [] }
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to replace agreement contacts');
  }
}

// DELETE
export async function deleteAgreementContact(agreementContactId, apiAccessToken) {
  try {
    const response = await axios.delete(`${baseUrl}/AgreementContacts/delete-agreement-contact/${agreementContactId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to delete agreement contact');
  }
}

// USERDEVICES
export async function getAllUserDevices(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/UserDevices/get-all-user-devices`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch user devices');
  }
}
export async function getUserDevicesByAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/UserDevices/get-user-devices-by-agreement/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch user devices');
  }
}
export async function getUserDevicesByAgreementHub(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/UserDevices/get-user-devices-by-agreement-hub/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch user devices');
  }
}

export async function getUserDevicesByUser(userPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/UserDevices/get-user-devices-by-user/${userPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch user devices');
  }
}
export async function getUserDeviceByPublicId(userDevicePublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/UserDevices/get-user-device-by-public-id/${userDevicePublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch user device');
  }
}
export async function createUserDevice(userDeviceData, apiAccessToken) {
  try {
    const response = await axios.post(`${baseUrl}/UserDevices/create-user-device`, userDeviceData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to create user device');
  }
}
export async function updateUserDevice(userDeviceData, apiAccessToken) {
  try {
    const response = await axios.put(`${baseUrl}/UserDevices/update-user-device`, userDeviceData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to update user device');
  }
}
export async function deleteUserDevice(userDevicePublicId, apiAccessToken) {
  try {
    const response = await axios.delete(`${baseUrl}/UserDevices/delete-user-device/${userDevicePublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to delete user device');
  }
}


// USERPROGRAMS
export async function getAllUserPrograms(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/UserPrograms/get-all-user-programs`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch user programs');
  }
}

export async function getUserProgramsByAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/UserPrograms/get-user-programs-by-agreement/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch user programs');
  }
}
export async function getUserProgramsByAgreementHub(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/UserPrograms/get-user-programs-by-agreement-hub/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch user programs');
  }
}

export async function getUserProgramsByUser(userPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/UserPrograms/get-user-programs-by-user/${userPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch user programs');
  }
}
export async function getUserProgramByPublicId(userProgramPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/UserPrograms/get-user-program-by-public-id/${userProgramPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to fetch user program');
  }
}
export async function createUserProgram(userProgramData, apiAccessToken) {
  try {
    const response = await axios.post(`${baseUrl}/UserPrograms/create-user-program`, userProgramData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to create user program');
  }
}
export async function updateUserProgram(userProgramData, apiAccessToken) {
  try {
    const response = await axios.put(`${baseUrl}/UserPrograms/update-user-program`, userProgramData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to update user program');
  }
}
export async function deleteUserProgram(userProgramPublicId, apiAccessToken) {
  try {
    const response = await axios.delete(`${baseUrl}/UserPrograms/delete-user-program/${userProgramPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || 'Failed to delete user program');
  }
}

// VALUE SUMMARY
export async function getAgreementValueSummary(officeBranch, apiAccessToken) {
  try {
    const params = new URLSearchParams();
    if (officeBranch) {
      params.append('officeBranch', officeBranch);
    }

    const response = await axios.get(`${baseUrl}/Agreements/value-summary${params.toString() ? '?' + params.toString() : ''}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to fetch agreement value summary');
  }
}

// DOMAINS
export async function getDomains(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/Domain/get-domains-by-agreement-public-id/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to fetch domains');
  }
} 

export async function updateBillingGroupOnDomains(nameSrsItemIds, billingGroupPublicId, apiAccessToken) {
  try {
    const response = await axios.post(
      `${baseUrl}/Domain/update-billinggroup-on-domains`,
      nameSrsItemIds, // BODY = [1887225, 12345]
      {
        params: {
          billingGroupPublicId, // ?billingGroupPublicId=BG124
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("API Request failed:", error.response?.data || error);
    throw new Error(
      error?.response?.data?.message ||
        "Failed to update billing group on domains"
    );
  }
}

// MANAGED DEVICES (Intune/Entra synced devices)
export async function getManagedDevicesByAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/ManagedDevices/get-by-agreement/${agreementPublicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to fetch managed devices');
  }
}

export async function getManagedDeviceByPublicId(publicId, apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/ManagedDevices/get-by-public-id/${publicId}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiAccessToken}`
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to fetch managed device');
  }
}

